export default __webpack_public_path__ + "21ce40ce5ebcbdcf9ebf61e33e149a4f.png";